// Calculator.js
'use strict';

class Calculator {
	canvas;
	ctx;
	image;
	lastX;
	lastY;

	scaleFactor = 1.1;
	zoomStep = 0;

	zoomMin = -10;
	zoomMax = 10;

	constructor() {
		// console.log('Calculator v1.0');
	}

	allowSortable() {
		// For anonymous function usage
		const that = this;

		if ($("#gates-wickets").length) {
			$("#gates-wickets").sortable({
				cancel: '.move-disabled',
				// tolerance: 'pointer',

				start: function (event, ui) {
					$("#fences").hide();
					$("#desks").hide();
					$("#columns").hide();
					$("#gates-wickets li.move-disabled").addClass('disabled-during-move');
				},
				stop: function (event, ui) {
					$.nette.ajax({
						'url': handleMoveUrl,
						'data': {
							data: {
								gate: $('#gates-wickets li.gate').index() > 0,
								wicket: $('#gates-wickets li.wicket').index() > 0,
								position: {
									gate: $('#gates-wickets li.gate').index(),
									wicket: $('#gates-wickets li.wicket').index()
								}
							}
						}
					}).done(function () {
							that.allowSortable();
						}(that)
					);

					/*
					if (typeof localStorage !== 'undefined') {
						localStorage.setItem('components', $(this).html());
					}
					*/
				}
			});

			$("#gates-wickets").disableSelection();
		}
	}

	trackTransforms() {
		const ctx = this.getContext();

		const svg = document.createElementNS("http://www.w3.org/2000/svg", 'svg');
		let xform = svg.createSVGMatrix();

		ctx.getTransform = function () {
			return xform;
		};

		let savedTransforms = [];

		const save = ctx.save;
		ctx.save = function () {
			savedTransforms.push(xform.translate(0, 0));
			return save.call(ctx);
		};

		const restore = ctx.restore;
		ctx.restore = function () {
			xform = savedTransforms.pop();
			return restore.call(ctx);
		};

		const scale = ctx.scale;
		ctx.scale = function (sx, sy) {
			xform = xform.scaleNonUniform(sx, sy);
			return scale.call(ctx, sx, sy);
		};

		const rotate = ctx.rotate;
		ctx.rotate = function (radians) {
			xform = xform.rotate(radians * 180 / Math.PI);
			return rotate.call(ctx, radians);
		};

		const translate = ctx.translate;
		ctx.translate = function (dx, dy) {
			xform = xform.translate(dx, dy);
			return translate.call(ctx, dx, dy);
		};

		const transform = ctx.transform;
		ctx.transform = function (a, b, c, d, e, f) {
			let m2 = svg.createSVGMatrix();
			m2.a = a;
			m2.b = b;
			m2.c = c;
			m2.d = d;
			m2.e = e;
			m2.f = f;
			xform = xform.multiply(m2);
			return transform.call(ctx, a, b, c, d, e, f);
		};

		const setTransform = ctx.setTransform;
		ctx.setTransform = function (a, b, c, d, e, f) {
			xform.a = a;
			xform.b = b;
			xform.c = c;
			xform.d = d;
			xform.e = e;
			xform.f = f;
			return setTransform.call(ctx, a, b, c, d, e, f);
		};

		let pt = svg.createSVGPoint();
		ctx.transformedPoint = function (x, y) {
			pt.x = x;
			pt.y = y;
			return pt.matrixTransform(xform.inverse());
		}
	}

	redraw() {
		const ctx = this.getContext();
		const canvas = this.getCanvas();
		const image = this.getImage();

		// Clear the entire canvas
		const p1 = ctx.transformedPoint(0, 0);
		const p2 = ctx.transformedPoint(canvas.width, canvas.height);
		ctx.clearRect(p1.x, p1.y, p2.x - p1.x, p2.y - p1.y);

		ctx.save();
		ctx.setTransform(1, 0, 0, 1, 0, 0);
		ctx.clearRect(0, 0, canvas.width, canvas.height);
		ctx.restore();

		this.setImage(image);
		// save_canvas(ctx, canvas);
	}

	move(x, y) {
		const ctx = this.getContext();
		ctx.translate(x, y);

		this.redraw();
	}


	zoom(clicks) {
		this.zoomStep += clicks;

		// console.log(this.zoomStep);

		if (this.zoomStep < this.zoomMin) {
			this.zoomStep = this.zoomMin;
			return false;
		} else if (this.zoomStep > this.zoomMax) {
			this.zoomStep = this.zoomMax;
			return false;
		}

		const ctx = this.getContext();

		const pt = ctx.transformedPoint(this.lastX, this.lastY);
		ctx.translate(pt.x, pt.y);

		const factor = Math.pow(this.scaleFactor, clicks);
		ctx.scale(factor, factor);
		ctx.translate(-pt.x, -pt.y);

		calc.redraw();

		return true;
	}

	showControls() {
		if ($('#controls').length) {
			$('#controls').show();
		}
	}

	hideControls() {
		if ($('#controls').length) {
			$('#controls').hide();
		}
	}

	showComponents() {
		if ($('#components').length) {
			$('#components').show();
		}
	}

	hideComponents() {
		if ($('#components').length) {
			$('#components').hide();
		}
	}

	showOnlyOneStep(step) {
		$('#steps .steps__select.step.step-' + step).show();
		$('#steps .steps__select.step:not(.step-' + step + ')').hide();
	}

	showAllSteps() {
		$('#steps .steps__select.step').show();
	}

	showStepExtra(step) {
		let $contentDefault = step.find('.default-content');
		let $contentExtra = step.find('.extra-content');

		if ($contentExtra.length) {
			$contentExtra.show();
			$contentDefault.hide();
		}
	}

	showStepDefault(step) {
		let $contentDefault = step.find('.default-content');
		let $contentExtra = step.find('.extra-content');

		if ($contentDefault.length) {
			$contentDefault.show();
			$contentExtra.hide();
		}
	}

	enableStep(step) {
		$('#steps .steps__select.step.step-' + step).removeClass('steps__select--disabled');
	}

	isCanvasReady(name) {
		return (document.getElementsByTagName(name)[0] !== undefined);
	}

	setCanvas(name) {
		this.canvas = document.getElementsByTagName(name)[0];
		this.canvas.width = 1000;
		this.canvas.height = 600;

		this.lastX = this.canvas.width / 2;
		this.lastY = this.canvas.height / 2;
	}

	getCanvas() {
		return this.canvas;
	}

	setContext() {
		const canvas = this.getCanvas();
		this.ctx = canvas.getContext('2d');
	}

	getContext() {
		return this.ctx;
	}

	setImage(image) {
		if (image == null) {
			return false;
		}

		this.image = image;

		const canvas = this.getCanvas();
		const ctx = this.getContext();

		/*
		// Centering image
		const imageX = (canvas.width - image.width) / 2;
		const imageY = (canvas.height - image.height) / 2;

		ctx.drawImage(image, imageX, imageY);
        */

		// Scale image
		this.drawImageScaled(image, ctx, canvas);
	}

	drawImageScaled(image, ctx, canvas) {
		const hRatio = canvas.width / image.width;
		const vRatio = canvas.height / image.height;
		const ratio = Math.min(hRatio, vRatio);
		const centerShift_x = (canvas.width - image.width * ratio) / 2;
		const centerShift_y = (canvas.height - image.height * ratio) / 2;

		ctx.clearRect(0, 0, canvas.width, canvas.height);

		ctx.drawImage(
			image,
			0, 0, image.width, image.height,
			centerShift_x, centerShift_y, image.width * ratio, image.height * ratio);
	}

	getImage() {
		return this.image;
	}
}
